const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_POOLS_ID,
      userPoolClientId: process.env.REACT_APP_WEBCLIENT_ID,
      loginWith: {
        email: true,
      },
    },
  },
};

export default awsConfig;
